import AcceptedIcon from '@/components/icons/statuses/AcceptedIcon.vue'
import CanceledIcon from '@/components/icons/statuses/CanceledIcon.vue'
import DeliveredIcon from '@/components/icons/statuses/DeliveredIcon.vue'
import DraftIcon from '@/components/icons/statuses/DraftIcon.vue'
import NotDeliveredIcon from '@/components/icons/statuses/NotDeliveredIcon.vue'
import PaidIcon from '@/components/icons/statuses/PaidIcon.vue'
import PaymentFailedIcon from '@/components/icons/statuses/PaymentFailedIcon.vue'
import CheckingDeliveryIcon from '@/components/icons/statuses/CheckingDeliveryIcon.vue'
import AcceptingIcon from '@/components/icons/statuses/AcceptingIcon.vue'
import LocatingIcon from '@/components/icons/statuses/LocatingIcon.vue'
import LostIcon from '@/components/icons/statuses/LostIcon.vue'
import SearchingIcon from '@/components/icons/statuses/SearchingIcon.vue'
import PaymentPendingIcon from '@/components/icons/statuses/PaymentPendingIcon.vue'
import LocatedIcon from '@/components/icons/statuses/LocatedIcon.vue'

import PlusIcon from '@/components/icons/PlusIcon.vue'
import FilterIcon from './FilterIcon.vue'
import ChevronIcon from './ChevronIcon.vue'
import SortIcon from './SortIcon.vue'
import CloseIcon from './CloseIcon.vue'
import CloseSmallIcon from './CloseSmallIcon.vue'
import TrashIcon from './TrashIcon.vue'
import UploadIcon from './UploadIcon.vue'
import EyeIcon from '@/components/icons/EyeIcon.vue'
import EyeClosedIcon from '@/components/icons/EyeClosedIcon.vue'
import OkIcon from '@/components/icons/OkIcon.vue'
import QuestionIcon from '@/components/icons/QuestionIcon.vue'
import OkSolidIcon from '@/components/icons/OkSolidIcon.vue'
import EditBoldIcon from '@/components/icons/EditBoldIcon.vue'
import DotsBoldIcon from '@/components/icons/DotsBoldIcon.vue'
import ErrorIcon from '@/components/icons/ErrorIcon.vue'
import ErrorSolidIcon from '@/components/icons/ErrorSolidIcon.vue'
import OffSolidIcon from '@/components/icons/OffSolidIcon.vue'
import PendingSolidIcon from '@/components/icons/PendingSolidIcon.vue'
import StopSolidIcon from '@/components/icons/StopSolidIcon.vue'
import BellIcon from '@/components/icons/BellIcon.vue'
import TrashThinIcon from '@/components/icons/TrashThinIcon.vue'
import WarningSolidIcon from '@/components/icons/WarningSolidIcon.vue'
import DownloadReportIcon from '@/components/icons/DownloadReportIcon.vue'
import ManagedOnIcon from '@/components/icons/ManagedOnIcon.vue'
import ManagedOffIcon from '@/components/icons/ManagedOffIcon.vue'
import CancelIcon from '@/components/icons/CancelIcon.vue'
import MoneySolidIcon from '@/components/icons/MoneySolidIcon.vue'
import HistoryIcon from '@/components/icons/HistoryIcon.vue'
import WarningBoldIcon from '@/components/icons/WarningBoldIcon.vue'
import ArrowReturnIcon from '@/components/icons/ArrowReturnIcon.vue'
import ArrowIcon from '@/components/icons/ArrowIcon.vue'
import ArrowDownBold from '@/components/icons/ArrowDownBold.vue'
import LensBoldIcon from '@/components/icons/LensBoldIcon.vue'
import BarcodeScannerIcon from '@/components/icons/BarcodeScannerIcon.vue'
import DoneIcon from '@/components/icons/DoneIcon.vue'
import MinusIcon from '@/components/icons/MinusIcon.vue'
import FileDownloadIcon from '@/components/icons/FileDownloadIcon.vue'
import ErrorSmallIcon from '@/components/icons/ErrorSmallIcon.vue'
import EditIcon from '@/components/icons/EditIcon.vue'
import MarkOkBoldIcon from '@/components/icons/MarkOkBoldIcon.vue'
import AlertCircleIcon from '@/components/icons/AlertCircleIcon.vue'
import BoxBoldIcon from '@/components/icons/BoxBoldIcon.vue'
import LinkExternalSmallIcon from '@/components/icons/LinkExternalSmallIcon.vue'
import InfoIcon from '@/components/icons/InfoIcon.vue'
import LinkExternalIcon from '@/components/icons/LinkExternalIcon.vue'
import ChevronSmallRightIcon from '@/components/icons/ChevronSmallRightIcon.vue'
import ChevronUpIcon from '@/components/icons/ChevronUpIcon.vue'
import AttachIcon from '@/components/icons/AttachIcon.vue'
import BoxSolidIcon from '@/components/icons/BoxSolidIcon.vue'
import NoneIcon from '@/components/icons/NoneIcon.vue'
import BoxIcon from '@/components/icons/BoxIcon.vue'
import ChevronLeftIcon from '@/components/icons/ChevronLeftIcon.vue'
import LoadingIcon from '@/components/icons/LoadingIcon.vue'
import CopyBoldIcon from '@/components/icons/CopyBoldIcon.vue'
import CopySmallIcon from '@/components/icons/CopySmallIcon.vue'
import MonitorIcon from '@/components/icons/MonitorIcon.vue'
import ShareIcon from '@/components/icons/ShareIcon.vue'
import SettingsIcon from '@/components/icons/SettingsIcon.vue'
import SyncIcon from '@/components/icons/SyncIcon.vue'
import PrinterBoldIcon from '@/components/icons/PrinterBoldIcon.vue'
import ClockIcon from '@/components/icons/ClockIcon.vue'
import CheckCircleIcon from '@/components/icons/CheckCircleIcon.vue'
import ArrowSolidIcon from '@/components/icons/ArrowSolidIcon.vue'
import InfoSmallIcon from '@/components/icons/InfoSmallIcon.vue'
import InventoryIcon from '@/components/icons/InventoryIcon.vue'
import ClockBoldIcon from '@/components/icons/ClockBoldIcon.vue'
import ExclamationIcon from '@/components/icons/ExclamationIcon.vue'
import GoogleIcon from '@/components/icons/GoogleIcon.vue'
import ArchiveIcon from '@/components/icons/ArchiveIcon.vue'
import OrdersIcon from '@/components/icons/OrdersIcon.vue'
import SendIcon from '@/components/icons/SendIcon.vue'
import AttachBoldIcon from '@/components/icons/AttachBoldIcon.vue'
import MessageIcon from '@/components/icons/MessageIcon.vue'
import ShipmentsIcon from '@/components/icons/ShipmentsIcon.vue'
import BillingIcon from '@/components/icons/BillingIcon.vue'
import TechincalIssuesIcon from '@/components/icons/TechincalIssuesIcon.vue'
import OtherIcon from '@/components/icons/OtherIcon.vue'
import WarehouseIcon from '@/components/icons/WarehouseIcon.vue'
import ForwardingIcon from '@/components/icons/ForwardingIcon.vue'

export const icons = {
  // plusIcon: () => import('./PlusIcon.vue') // можем использовать динамические импорты, если бандл будет слишком большой

  // statuses
  AcceptedIcon,
  CanceledIcon,
  DeliveredIcon,
  DraftIcon,
  NotDeliveredIcon,
  PaidIcon,
  PaymentFailedIcon,
  PaymentPendingIcon,
  CheckingDeliveryIcon,
  AcceptingIcon,
  LocatingIcon,
  LostIcon,
  SearchingIcon,
  LocatedIcon,

  PlusIcon,
  FilterIcon,
  ChevronIcon,
  SortIcon,
  CloseIcon,
  CloseSmallIcon,
  TrashIcon,
  TrashThinIcon,
  UploadIcon,
  EyeIcon,
  EyeClosedIcon,
  OkIcon,
  OkSolidIcon,
  EditIcon,
  EditBoldIcon,
  DotsBoldIcon,
  QuestionIcon,
  ErrorIcon,
  ErrorSolidIcon,
  OffSolidIcon,
  PendingSolidIcon,
  StopSolidIcon,
  BellIcon,
  WarningSolidIcon,
  DownloadReportIcon,
  ManagedOnIcon,
  ManagedOffIcon,
  CancelIcon,
  MoneySolidIcon,
  HistoryIcon,
  WarningBoldIcon,
  MinusIcon,
  ArrowReturnIcon,
  ArrowIcon,
  ArrowDownBold,
  LensBoldIcon,
  BarcodeScannerIcon,
  DoneIcon,
  FileDownloadIcon,
  ErrorSmallIcon,
  MarkOkBoldIcon,
  AlertCircleIcon,
  BoxBoldIcon,
  LinkExternalSmallIcon,
  LinkExternalIcon,
  InfoIcon,
  ChevronSmallRightIcon,
  ChevronUpIcon,
  AttachIcon,
  BoxSolidIcon,
  NoneIcon,
  BoxIcon,
  ChevronLeftIcon,
  LoadingIcon,
  CopyBoldIcon,
  CopySmallIcon,
  MonitorIcon,
  ShareIcon,
  SettingsIcon,
  SyncIcon,
  PrinterBoldIcon,
  ClockIcon,
  CheckCircleIcon,
  ArrowSolidIcon,
  InfoSmallIcon,
  InventoryIcon,
  ClockBoldIcon,
  ExclamationIcon,
  GoogleIcon,
  ArchiveIcon,
  OrdersIcon,
  SendIcon,
  AttachBoldIcon,
  MessageIcon,
  ShipmentsIcon,
  BillingIcon,
  TechincalIssuesIcon,
  OtherIcon,
  WarehouseIcon,
  ForwardingIcon,
}

export type IconName = keyof typeof icons

export const getIcon = (iconName: IconName) => {
  const iconComponent = icons[iconName]
  if (iconComponent) return iconComponent

  throw new Error(`Icon "${iconName}" not found`)
}
